import * as React from "react";
import styled, { css } from "../../../styled";
import { CoreUtils } from "@lib/common";
const { shadeAlternate } = CoreUtils.colors;
export const Tabs = styled("div") `
  background: ${({ theme }) => shadeAlternate(0.08, theme.box.background)};
  display: flex;
  justify-content: space-between;
`;
export const Tab = styled("div") `
  flex-grow: 1;
  flex-basis: 0;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.11, theme.box.background)};
  }
  ${({ active }) => !active ? "" : css `
    .tab-line {
      background: ${({ theme }) => theme.colors.primary};
    }
  `};
`;
export const TabLabel = styled("div") `
  text-align: center;
  padding: 15px 0;
`;
export const TabLine = styled("div") `
  height: 2px;
  width: 100%;
  background: ${({ theme }) => shadeAlternate(0.2, theme.box.background)};
`;
export class ModalTabs extends React.Component {
    render() {
        const { tabs, value, onChange } = this.props;
        return (React.createElement(Tabs, null, tabs.map((t, i) => (React.createElement(Tab, { key: i, active: t.value === value, onClick: () => onChange(t) },
            React.createElement(TabLabel, null, t.label),
            React.createElement(TabLine, { className: "tab-line" }))))));
    }
}
//# sourceMappingURL=tabs.js.map